import { DataFieldModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export class RemoteDepositDataField extends DomainEntity<DataFieldModelDto> {
    public createDefault(): this {
        return new RemoteDepositDataField({ fieldType: 0, isRequired: false }) as this;
    }

    public get text() {
        return this.dto.text;
    }

    public get value(): string | undefined {
        return this.dto.value;
    }

    public set value(value: string) {
        this.dto.value = value;
    }

    public get fieldName() {
        return this.dto.fieldName;
    }

    public get isRequired() {
        return this.dto.isRequired;
    }
}
